import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';
import { unique } from '@/modules/common/helpers/array';

type State = {
  collisionState: Map<string, string[]>;
};

const INITIAL_STATE: State = {
  collisionState: new Map(),
};

type Action = {
  add(idA: string, idB: string): void;
  remove(idA: string, idB: string): void;
  reset(): void;
};

export const useCollisionStore = create<State & Action>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      add(idA: string, idB: string) {
        set(
          (state) => {
            const updatedCollisionState = new Map(state.collisionState);
            updatedCollisionState.set(
              idA,
              unique([...(updatedCollisionState.get(idA) || []), idB]),
            );
            return { collisionState: updatedCollisionState };
          },
          undefined,
          {
            type: 'add',
          },
        );
      },

      remove(idA: string, idB: string) {
        set(
          (state) => {
            const updatedCollisionState = new Map(state.collisionState);
            updatedCollisionState.set(
              idA,
              (updatedCollisionState.get(idA) || []).filter((id) => id !== idB),
            );

            if (updatedCollisionState.get(idA)?.length === 0) {
              updatedCollisionState.delete(idA);
            }

            return { collisionState: updatedCollisionState };
          },
          undefined,
          {
            type: 'remove',
          },
        );
      },

      reset() {
        set(INITIAL_STATE, undefined, {
          type: 'reset',
        });
      },
    }),
    { store: 'collisionStore', ...DEVTOOLS_OPTIONS },
  ),
);
